// removed by extract-text-webpack-plugin
module.exports = {"previewTitle":"src-components----article-preview-module---previewTitle---16pYm","tag":"src-components----article-preview-module---tag---27JAs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/article-preview.module.css
// module id = 262
// module chunks = 35783957827783